import { render, staticRenderFns } from "./JSMComplaint.vue?vue&type=template&id=fe6730c8&scoped=true"
import script from "./JSMComplaint.vue?vue&type=script&lang=js"
export * from "./JSMComplaint.vue?vue&type=script&lang=js"
import style0 from "@/assets/styles/beneficiary.css?vue&type=style&index=0&id=fe6730c8&prod&scoped=true&lang=css&external"
import style1 from "./JSMComplaint.vue?vue&type=style&index=1&id=fe6730c8&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fe6730c8",
  null
  
)

export default component.exports